import {TextUtil} from "base/utilities";

export function useETAPTable() {
    const tableColumns = [
        {
            id: "codigo",
            label: "Código",
            width: 15,
        },
        {
            id: "abastecemento_autonomo",
            label: "A.A.",
            width: 10,
            formatFunction: element =>
                TextUtil.formatBoolean(element.abastecemento_autonomo),
        },
        {
            id: "titular_label",
            label: "Titular",
            width: 25,
        },
        {
            id: "xestion_label",
            label: "Xestión",
            width: 25,
        },
        {
            id: "estado_label",
            label: "Estado",
            width: 25,
        },
    ];

    return {tableColumns};
}
